export default "__VITE_ASSET__CrZpGy5V__"